import { c as _c } from "react/compiler-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import FullWidthContainer from 'components/consumer/FullWidthContainer';
import LogoLink from 'components/consumer/LogoLink';
import HeaderToolbar from 'components/nav/shared/HeaderToolbar';
import ConsumerSearchBar from 'components/consumer/consumer-search/ConsumerSearchBar';
import BrowserOnly from 'components/consumer/BrowserOnly';
import DesktopNavCategories from '../DesktopNavCategories';
const DesktopPrimaryNav = t0 => {
  const $ = _c(10);
  const {
    selectedCategoryId,
    setIsLinkHovered
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <LogoLink />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== selectedCategoryId || $[2] !== setIsLinkHovered) {
    t2 = <DesktopNavCategories selectedCategoryId={selectedCategoryId} setIsLinkHovered={setIsLinkHovered} />;
    $[1] = selectedCategoryId;
    $[2] = setIsLinkHovered;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <HeaderToolbar />;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== t2) {
    t4 = <FullWidthContainer className="items-center flex justify-between max-[1023px]:z-11 lg:!z-[1003] relative bg-white" data-xc="DesktopPrimaryNav" hasPadding={true}>{t1}{t2}{t3}</FullWidthContainer>;
    $[5] = t2;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <BrowserOnly><FullWidthContainer><ConsumerSearchBar /></FullWidthContainer></BrowserOnly>;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== t4) {
    t6 = <FullWidthContainer>{t4}{t5}</FullWidthContainer>;
    $[8] = t4;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  return t6;
};
DesktopPrimaryNav.propTypes = {
  selectedCategoryId: PropTypes.string,
  setIsLinkHovered: PropTypes.func
};
export default DesktopPrimaryNav;